module.exports = __webpack_public_path__ + "media/images/front/favicon-16x16-0dea5d968da03babb22068ba297f40f5.png";